import { useSelector, useDispatch } from "react-redux";
import ReviewCard from "../cards/ReviewCard";
import { Col, Input, Row } from "reactstrap";
import { useEffect, useState } from "react";
import { postReview } from "../../apis/ReviewApi";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "../../languages";

const ResturantReviews = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const user = useSelector((s) => s?.user ?? {});
  const placeDetails = useSelector((s) => s?.placeDetails ?? {});

  //all local states
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(1);
  const [newReview, setNewReview] = useState("");

  const addReview = () => {
    let obj = {
      rating,
      comment: newReview,
    };
    postReview(id, obj, (res) => {
      if (res?.success) {
        toast.success("Review Added Successfully");

        // Format new review same as existing reviews
        const formattedReview = {
          rating,
          comment: newReview,
          user: {
            name: {
              first: user?.name?.first ?? "",
              last: user?.name?.last ?? "",
            },
            profilePicture: user?.profilePicture ?? "",
          },
        };

        // update local state immediately
        setReviews((prev) => [...prev, formattedReview]);
      } else {
        toast.error(res?.response?.data?.message);
      }
    });
    setNewReview("");
  };

  //all useEffects
  useEffect(() => {
    let reviews = placeDetails?.reviews ?? [];
    if (reviews?.length > 0) {
      setReviews(placeDetails?.reviews);
    }
  }, [placeDetails?.reviews]);

  return (
    <div className="resturant-detail-div">
      <h4
        className="f-5 text-white mb-3 py-2 text-center"
        style={{ letterSpacing: "9px" }}
      >
        Reviews
      </h4>
      {reviews?.length > 0 ? (
        <div>
          <h5 className="f-6 baloo-font">Reviews (Top)</h5>
          <div>
            {reviews?.map((item, key) => (
              <ReviewCard
                key={key}
                by={{
                  name: `${item?.user?.name?.first ?? ""} ${
                    item?.user?.name?.last ?? ""
                  }`.trim(),
                }}
                profilePicture={item?.user?.profilePicture}
                ratings={item?.rating}
                review={item?.comment}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center text-center fw-bold h1 w-100 py-5 text-white">
          {t("noReviewsAddedYet")}
        </div>
      )}

      {user?.roles?.includes("user")&& (
        <Row className="mt-5 d-flex align-items-center justify-content-center">
          <Col md={6} className="mt-4">
            <div className="d-flex flex-column mb-3">
              <label htmlFor="">Rating</label>
              <select
                className="form-select"
                value={rating}
                onChange={(e) => setRating(Number(e.target.value))}
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>

            <label htmlFor="">Review</label>

            <Input
              style={{ height: "100px" }}
              type="textarea"
              placeholder="Write review here..."
              value={newReview}
              onChange={(e) => setNewReview(e.target.value)}
            />

            <div className="d-flex justify-content-end">
              <button
                className="btn color-primary-blue btn-md border-none f-5 bg-primary-half-blue py-md-3 py-2 mt-5 fs-4 text-bold"
                onClick={addReview}
              >
                Add Review
              </button>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default ResturantReviews;
